import React, { useContext, useEffect, useState } from "react";
import { Form, Modal } from "react-bootstrap";
import "./OrderTrackModal.css";
import OrderInfoForModal from "./order_info_for_modal/OrderInfoForModal";
import OrderProgressStepper from "./order_progress_stepper/OrderProgressStepper";
import Gray_Outline_Button from "../../common-btn/gray_outline_btn/Gray_Outline_Button";

function OrderTrackModal({ data, ...props }) {
  const { show, onHide, modal_title, order } = props;

  const handleReasonChange = (event) => {
    props.setValue("order_cancel_reason_id", event.target.value);
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="md"
      className="OrderTrackModal Modal-holder"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <div className="heading_part">
        <OrderInfoForModal order={data} onHide={onHide} />
      </div>
      <Modal.Body>
        <div className="main_container">
          <div className="stepper">
            <OrderProgressStepper order={data} />
          </div>

          <div className="close_btn_holder">
            <Gray_Outline_Button
              btnText={"Close"}
              onClick={() => {
                props?.onHide();
              }}
            />
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default OrderTrackModal;
